import {TableColumn} from '@fl/cmsch-fe-library';

import {AssociationRoleTableType} from '../../types/association-role-table-type';

/** Table columns for the association tab. */
export const columns: Array<TableColumn<AssociationRoleTableType>> = [
    {
        field: 'associationId',
        type: 'number',
        align: 'left',
    },
    {
        field: 'associationName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'approvedFrom',
        type: 'date',
        dateFormat: 'date',
    },
    {
        field: 'approvedTo',
        type: 'date',
        dateFormat: 'date',
        filterTypes: ['null'],
    },
    {
        field: 'roleCode',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'roleName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
];
